import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { Store } from "./redux/Store";
import App from "./App";
import "./styles.css";
import { registerServiceWorker } from "./utils/installApp";

// Entry point: mounts the app inside the Redux provider
const root = createRoot(document.getElementById("root"));
registerServiceWorker(); // the admin panel can be installed as an app

root.render(
  <React.StrictMode>
    <Provider store={Store}>
      <App />
    </Provider>
  </React.StrictMode>
);
